<div class="dialog" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-icon>create</mat-icon>
        <h1 *ngIf="!isAdded">{{'フロア・表示グループ情報：編集' | translate}}</h1>
        <h1 *ngIf="!!isAdded">{{'フロア・表示グループ情報：追加' | translate}}</h1>
      </div>

      <div fxLayout="row" fxLayoutGap="10px">
        <button mat-raised-button color="primary" (click)="addFloor()" [disabled]="!floorFormGroup.valid">
          <mat-icon>add</mat-icon>
          <span *ngIf="!isAdded">{{'更新' | translate}}</span>
          <span *ngIf="!!isAdded">{{'追加' | translate}}</span>
        </button>
        <button mat-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div mat-dialog-content>
    <form class="form" [formGroup]="floorFormGroup">
      <div class="dialog-body" fxLayout="row" fxLayoutGap="24px">

        <div class="dialog-left" fxLayout="column" fxLayoutGap="20px" fxFlex="100%">
          <div fxLayout="row" fxLayoutGap="20px">
            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">ID</mat-label>
              <input matInput *ngIf="!isAdded" placeholder="ID" id="floorId" formControlName="floorId" readonly>
              <input matInput *ngIf="!!isAdded" placeholder="ID" id="floorId" formControlName="floorId">
              <mat-error *ngIf="floorIdControl.invalid">{{ getErrorMessageToFloorId() }}</mat-error>
            </mat-form-field>

          </div>

          <mat-form-field>
            <mat-label floatLabel="always">{{'名称' | translate}}</mat-label>
            <input matInput placeholder="{{'名称' | translate}}" id="floorNames"
              value="{{ floor!.floor_names | multiName:projectLanguages:projectBaseLang }}" readonly>
            <button matSuffix mat-stroked-button color="primary" (click)="openFloorNameDialog()">
              <mat-icon>edit</mat-icon>
            </button>
          </mat-form-field>

          <mat-form-field>
            <mat-label floatLabel="always">{{'説明' | translate}}</mat-label>
            <input matInput placeholder="{{'説明' | translate}}" id="floorExplain" formControlName="floorExplain">
          </mat-form-field>

          <mat-form-field>
            <mat-label floatLabel="always">{{'建物・カテゴリ説明' | translate}}</mat-label>
            <mat-select placeholder="{{'建物・カテゴリ' | translate}}" id="hallId" formControlName="hallId">
              <mat-option *ngFor="let hall of (halls | async)" [value]="hall.hall_id">
                {{ hall.hall_names | multiName:projectLanguages:projectBaseLang }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="hallIdControl.invalid">{{ getErrorMessageToHallId() }}</mat-error>
          </mat-form-field>

          <mat-form-field>
            <mat-label floatLabel="always">{{'詳細' | translate}}</mat-label>
            <textarea matInput placeholder="{{'詳細' | translate}}" id="floorDescs" rows="3"
              value="{{ floor!.floor_descs | multiDesc:projectLanguages:projectBaseLang }}" readonly></textarea>
            <button matSuffix mat-stroked-button color="primary" (click)="openFloorDescDialog()">
              <mat-icon>edit</mat-icon>
            </button>
            <mat-error *ngIf="floorDescsControl.invalid">{{ getErrorMessageToFloorDescs() }}</mat-error>
          </mat-form-field>

          <google-map *ngIf="center" height="400px" width="100%" step="0.00000001" [center]="center" [zoom]="zoom"
            [options]="options">
            <map-marker #markerElem *ngIf="currentPosition" step="0.00000001" [position]="currentPosition"
              [options]="currentPositionMarkerOption" (mapDragend)="onMerkerDragEnd($event)">
            </map-marker>
          </google-map>
          <input #mapSearchField class="map-search-field" type="text"
            (keydown)="onKeyDownFromSearchPlace($event.keyCode)" />
          <button #mapSearchFieldExecute (click)="searchMap()">{{'移動' | translate}}</button>
          <button #mapSearchFieldClear (click)="clearMapSearchField()">{{'クリア' |
            translate}}</button>

          <div class="floor-area" fxLayout="row" fxLayoutGap="20px">
            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'緯度' | translate}}</mat-label>
              <input matInput placeholder="{{'緯度' | translate}}" id="floorLat" formControlName="floorLat" type="number"
                step="0.00000001" (change)="onBlurMarkerLat()">
              <mat-error *ngIf="floorLatControl.invalid">{{ getErrorMessageToFloorLat() }}</mat-error>
            </mat-form-field>

            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'経度' | translate}}</mat-label>
              <input matInput placeholder="{{'経度' | translate}}" id="floorLng" formControlName="floorLng" type="number"
                step="0.00000001" (change)="onBlurMarkerLng()">
              <mat-error *ngIf="floorLngControl.invalid">{{ getErrorMessageToFloorLng() }}</mat-error>
            </mat-form-field>
          </div>

          <mat-checkbox formControlName="showMarker" color="primary">{{'MAPページに位置を表示する' |
            translate}}</mat-checkbox>

        </div>

        <div class="dialog-right" fxLayout="column" fxLayoutGap="20px" fxFlex="100%">

          <mat-checkbox formControlName="useExternallink" color="primary">{{'外部リンクを使用する' |
            translate}}</mat-checkbox>

          <mat-form-field>
            <mat-label floatLabel="always">{{'外部リンク名称' | translate}}</mat-label>
            <input matInput placeholder="{{'外部リンク名称' | translate}}" id="externallinkNames"
              value="{{ floor!.externallink_names | multiName:projectLanguages:projectBaseLang }}" readonly>
            <button matSuffix mat-stroked-button color="primary" (click)="openExternallinkNameDialog()">
              <mat-icon>edit</mat-icon>
            </button>
          </mat-form-field>

          <mat-form-field>
            <mat-label floatLabel="always">{{'外部リンクＵＲＬ' | translate}}</mat-label>
            <input matInput placeholder="{{'外部リンクＵＲＬ' | translate}}" id="externallinkUrls"
              value="{{ floor!.externallink_urls | multiCode:projectLanguages:projectBaseLang }}" readonly>
            <button matSuffix mat-stroked-button color="primary" (click)="openExternallinkUrlDialog()">
              <mat-icon>edit</mat-icon>
            </button>
          </mat-form-field>

          <div fxLayout="row" fxLayoutGap="10px">
            <mat-form-field fxFlex="50%">
              <mat-label>{{'開催期間(開始日)' | translate}}</mat-label>
              <input matInput [matDatepicker]="eventStartDatePicker" placeholder="{{'開催期間(開始日)' | translate}}"
                formControlName="eventStartDate" readonly>
              <button class="clear-button" mat-button matSuffix aria-label="Clear" (click)="clearEventStartDate()">
                <mat-icon>close</mat-icon>
              </button>
              <mat-datepicker-toggle matSuffix [for]="$any(eventStartDatePicker)"></mat-datepicker-toggle>
              <mat-datepicker #eventStartDatePicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field fxFlex="50%">
              <mat-label>{{'開催期間(終了日)' | translate}}</mat-label>
              <input matInput [matDatepicker]="eventEndDatePicker" placeholder="{{'開催期間(終了日)' | translate}}"
                formControlName="eventEndDate" readonly>
              <button class="clear-button" mat-button matSuffix aria-label="Clear" (click)="clearEventEndDate()">
                <mat-icon>close</mat-icon>
              </button>
              <mat-datepicker-toggle matSuffix [for]="$any(eventEndDatePicker)"></mat-datepicker-toggle>
              <mat-datepicker #eventEndDatePicker></mat-datepicker>
              <mat-error *ngIf="eventEndDateControl.hasError('before_start_date')">{{ getErrorMessageToEventEndDate()
                }}</mat-error>
            </mat-form-field>
          </div>

          <div class="floor-files">
            <div class="floor-files-title" fxLayout="row" fxLayoutAlign="space-between end">
              <span>{{'フロア・表示グループ画像ファイル' | translate}}（ {{ !!floor!.floor_files ?
                floor!.floor_files.length:0 }}
                {{'件' | translate}}）</span>
              <button mat-stroked-button (click)="openSelectFilesDialog()">
                <mat-icon>add</mat-icon>
                <span>{{'ファイル追加' | translate}}</span>
              </button>
            </div>

            <table>
              <thead>
                <tr>
                  <th>{{'画像' | translate}}</th>
                  <th>{{'名称' | translate}}</th>
                  <th style="width: 100px;">{{'言語' | translate}}</th>
                  <th>{{'削除' | translate}}</th>
                </tr>
              </thead>
              <tbody cdkDropList class="cdk-table" (cdkDropListDropped)="onDropFile($event)">
                <tr *ngFor="let floorFile of floorFiles; let i=index" cdkDrag cdkDragLockAxis="y">
                  <td><img [src]="floorFile.download_url" height="40px" width="auto"></td>
                  <td>{{ floorFile.file_name }}</td>
                  <td>
                    <mat-select id="lang" [value]="floorFile.lang_code"
                      (selectionChange)="changeFloorFileLang(i, $event)">
                      <ng-container *ngFor="let language of projectLanguages">
                        <mat-option [value]="language.lang_code">
                          {{ projectBaseLang == 'ja' ?  language.lang_name : language.lang_name_en }}
                        </mat-option>
                      </ng-container>
                    </mat-select>
                  </td>
                  <td>
                    <button mat-stroked-button color="warn" (click)="deleteFiles(i)">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <mat-checkbox formControlName="floorFileExpand" color="primary">{{'フロア・表示グループ画像ファイルを拡大表示する' |
            translate}}</mat-checkbox>

          <div class="exhibit-list">
            <div class="exhibit-list-title" fxLayout="row" fxLayoutAlign="space-between end">
              <span>{{'展示リスト' | translate}}（ {{ !!floor!.exhibit_ids ?
                floor!.exhibit_ids.length:0
                }} {{'件' | translate}}）</span>
              <button mat-stroked-button (click)="openSelectExhibitsDialog()">
                <mat-icon>add</mat-icon>
                <span>{{'展示リスト追加' | translate}}</span>
              </button>
            </div>

            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>{{'名称' | translate}}</th>
                  <th>{{'削除' | translate}}</th>
                </tr>
              </thead>
              <tbody cdkDropList class="cdk-table" (cdkDropListDropped)="onDropExhibit($event)">
                <tr *ngFor="let exhibit of exhibits" cdkDrag cdkDragLockAxis="y">
                  <td>{{ exhibit.exhibit_id }}</td>
                  <td>{{ exhibit.exhibit_names | multiName:projectLanguages:projectBaseLang }}</td>
                  <td>
                    <button mat-stroked-button color="warn" (click)="deleteExhibit(exhibit.id!)">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </form>
  </div>


</div>